import {ModalCopy_CurrentStep, ModalCopy_Type} from "../@const"
import Goal from "../../../model2/goal/goal"
import ApiGoal from "../../../gd/api/goal"
import {Copy_Manager} from "./manager"

// const debug = "CopyGoal_Manager"
const debug = false

export class CopyGoal_Manager extends Copy_Manager{

    public goalToCopy: Goal

    constructor(goal: Goal) {
        super(ModalCopy_Type.GOAL)

        this.goalToCopy = goal
    }

    init = async () => {
        this.setCurrentStep(ModalCopy_CurrentStep.COPY_GOAL)
    }

    get modalTitle():string {
        return 'Duplicate Goal'
    }

    async commitCopy(result: any) {
        if (result) this.result = result

        const data = {
            newName     : this.result.title,

            copySubGoals: this.result.copyOptions.includes("copySubGoals"),
            copyProgress: this.result.copyOptions.includes("copyProgress"),
            copyUsers   : this.result.copyOptions.includes("copyUsers"),
        }

        await ApiGoal.duplicate(this.goalToCopy.id, data).promise()

        this.onCopy?.()
        gd.modal.hide()
    }
}